module.exports = __webpack_public_path__ + "img/stripe.ef3f8a47.svg";